import { cn } from "@/lib/cn";

export function Workspace({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={cn("panel overflow-hidden rounded-3xl", className)}>
      {children}
    </div>
  );
}

export function WorkspaceSection({
  children,
  className,
  border = false,
}: {
  children: React.ReactNode;
  className?: string;
  border?: boolean;
}) {
  return (
    <section className={cn(border && "border-t border-border/30", className)}>
      {children}
    </section>
  );
}

export function FieldLabel({
  icon,
  children,
}: {
  icon?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <span className="mb-1.5 flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-muted">
      {icon ? <span className="text-foreground">{icon}</span> : null}
      {children}
    </span>
  );
}
